var _path, _path2, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferCrisps(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Crisps",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.578,
    height: 27.764,
    viewBox: "0 0 21.578 27.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5823",
    "data-name": "Path 5823",
    d: "M10.417,12.494V23.241A6.528,6.528,0,0,1,9.9,25.8L8.746,28.465H30.1l-1.149-2.693a6.528,6.528,0,0,1-.522-2.555V12.47a6.559,6.559,0,0,1,.521-2.554L30.137,7.15H8.72L9.9,9.914a6.559,6.559,0,0,1,.522,2.579Z",
    transform: "translate(-8.636 -3.836)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5824",
    "data-name": "Path 5824",
    d: "M30.158,43.78H8.58v2.579H30.158V43.78Z",
    transform: "translate(-8.58 -18.596)",
    fill: "#ed8b00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5049",
    "data-name": "Rectangle 5049",
    width: 21.578,
    height: 2.854,
    transform: "translate(0)",
    fill: "#ed8b00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13181",
    "data-name": "Group 13181",
    transform: "translate(5.11 8.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5849",
    "data-name": "Path 5849",
    d: "M37.894,47.834a.834.834,0,0,1-.337-.062.5.5,0,0,1-.3-.323.609.609,0,0,1,.036-.457,2.987,2.987,0,0,0,.29-1.127,2.291,2.291,0,0,1,.877-1.66,4.4,4.4,0,0,1-.75-.7l-.062-.08a1.812,1.812,0,0,1-.192-1.878,1.874,1.874,0,0,1,1.588-1.087,3.089,3.089,0,0,1,1.6.362s1.533.7,1,3.056a5.578,5.578,0,0,1-2.44,3.625A3.625,3.625,0,0,1,37.894,47.834Zm.87-3.407a1.864,1.864,0,0,0-.845,1.45,3.212,3.212,0,0,1-.323,1.269.3.3,0,0,0-.018.214.181.181,0,0,0,.109.116,2.362,2.362,0,0,0,1.37-.3,3.752,3.752,0,0,0,.605-.457.236.236,0,0,1,0-.069C40.214,45.5,39.576,45.024,38.764,44.426Zm.141-.312.051.036c.689.507,1.4,1.029,1.232,2a5.738,5.738,0,0,0,1.131-2.371c.471-2.077-.761-2.657-.816-2.679a2.726,2.726,0,0,0-1.432-.319,1.541,1.541,0,0,0-1.309.91,1.5,1.5,0,0,0,.156,1.541l.054.069a4.981,4.981,0,0,0,.924.812Z",
    transform: "translate(-30.398 -37.496)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1004",
    "data-name": "Ellipse 1004",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.685 3.74)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5850",
    "data-name": "Path 5850",
    d: "M42.214,42.635a.174.174,0,0,1-.174-.174.181.181,0,1,1,.362,0,.174.174,0,0,1-.188.174Zm0-.218a.044.044,0,0,0-.04.044c0,.043.08.043.08,0A.043.043,0,0,0,42.214,42.418Z",
    transform: "translate(-33.464 -38.656)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1005",
    "data-name": "Ellipse 1005",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(7.732 4.291)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5851",
    "data-name": "Path 5851",
    d: "M39.584,44.168a.174.174,0,1,1,.174-.174.174.174,0,0,1-.174.174Zm0-.214a.04.04,0,0,0-.044.04c0,.047.083.047.083,0A.04.04,0,0,0,39.584,43.954Z",
    transform: "translate(-31.787 -39.638)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1006",
    "data-name": "Ellipse 1006",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.558 4.501)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5852",
    "data-name": "Path 5852",
    d: "M41.851,44.745a.178.178,0,1,1,.174-.178.178.178,0,0,1-.174.178Zm0-.217a.04.04,0,0,0-.044.04c0,.047.083.047.083,0A.04.04,0,0,0,41.851,44.528Z",
    transform: "translate(-33.228 -40.001)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1007",
    "data-name": "Ellipse 1007",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.533 5.157)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5853",
    "data-name": "Path 5853",
    d: "M41.794,46.558a.174.174,0,1,1,.174-.174.17.17,0,0,1-.174.174Zm0-.214a.04.04,0,0,0-.04.04c0,.047.08.047.08,0A.04.04,0,0,0,41.794,46.344Z",
    transform: "translate(-33.196 -41.161)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1008",
    "data-name": "Ellipse 1008",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(9.323 4.871)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5854",
    "data-name": "Path 5854",
    d: "M43.968,45.765a.178.178,0,1,1,.178-.178A.178.178,0,0,1,43.968,45.765Zm0-.218a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.04.04,0,0,0-.044-.04Z",
    transform: "translate(-34.579 -40.651)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1009",
    "data-name": "Ellipse 1009",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(10.008 4.157)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5855",
    "data-name": "Path 5855",
    d: "M45.864,43.8a.174.174,0,1,1,.174-.174.17.17,0,0,1-.174.174Zm0-.214a.04.04,0,0,0-.04.04c0,.047.08.047.08,0A.04.04,0,0,0,45.864,43.584Z",
    transform: "translate(-35.791 -39.402)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1010",
    "data-name": "Ellipse 1010",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(9.961 5.241)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M45.681,46.785a.178.178,0,1,1,.174-.178.178.178,0,0,1-.174.178Zm0-.218a.04.04,0,0,0-.043.04c0,.047.083.047.083,0A.04.04,0,0,0,45.681,46.568Z",
    transform: "translate(-35.669 -41.302)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1011",
    "data-name": "Ellipse 1011",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(9.475 5.817)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M44.381,48.375a.178.178,0,1,1,.174-.178.174.174,0,0,1-.174.178Zm0-.217a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.044.044,0,0,0-.043-.04Z",
    transform: "translate(-34.841 -42.315)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1012",
    "data-name": "Ellipse 1012",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(10.095 6.47)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5858",
    "data-name": "Path 5858",
    d: "M46.091,50.165a.178.178,0,1,1,.174-.174A.178.178,0,0,1,46.091,50.165Zm0-.217a.043.043,0,0,0-.043.043c0,.043.083.043.083,0a.04.04,0,0,0-.04-.044Z",
    transform: "translate(-35.931 -43.456)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1013",
    "data-name": "Ellipse 1013",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(9.827 7.242)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5859",
    "data-name": "Path 5859",
    d: "M45.351,52.283a.181.181,0,1,1,.181-.181A.181.181,0,0,1,45.351,52.283Zm0-.217a.043.043,0,0,0-.043.044c0,.043.083.043.083,0a.04.04,0,0,0-.04-.043Z",
    transform: "translate(-35.459 -44.801)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1014",
    "data-name": "Ellipse 1014",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.867 8.362)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5860",
    "data-name": "Path 5860",
    d: "M42.694,55.388a.174.174,0,1,1,.174-.174.174.174,0,0,1-.174.174Zm0-.214a.04.04,0,0,0-.044.04c0,.047.083.047.083,0a.04.04,0,0,0-.04-.036Z",
    transform: "translate(-33.77 -46.79)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1015",
    "data-name": "Ellipse 1015",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.145 8.362)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5861",
    "data-name": "Path 5861",
    d: "M40.694,55.388a.174.174,0,1,1,.174-.174A.174.174,0,0,1,40.694,55.388Zm0-.214a.04.04,0,0,0-.043.04c0,.047.083.047.083,0a.04.04,0,0,0-.04-.036Z",
    transform: "translate(-32.495 -46.79)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1016",
    "data-name": "Ellipse 1016",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(7.812 9.33)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5862",
    "data-name": "Path 5862",
    d: "M39.8,58.045a.178.178,0,1,1,.178-.178A.178.178,0,0,1,39.8,58.045Zm0-.218a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.04.04,0,0,0-.043-.04Z",
    transform: "translate(-31.921 -48.48)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1017",
    "data-name": "Ellipse 1017",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.359 8.898)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5863",
    "data-name": "Path 5863",
    d: "M41.308,56.875a.178.178,0,1,1,.178-.178A.178.178,0,0,1,41.308,56.875Zm0-.218a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.04.04,0,0,0-.044-.04Z",
    transform: "translate(-32.884 -47.734)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1018",
    "data-name": "Ellipse 1018",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(10.69 5.513)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5864",
    "data-name": "Path 5864",
    d: "M47.738,47.525a.178.178,0,1,1,.178-.174A.178.178,0,0,1,47.738,47.525Zm0-.217a.04.04,0,0,0-.04.044c0,.043.083.043.083,0a.044.044,0,0,0-.043-.044Z",
    transform: "translate(-36.983 -41.773)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1019",
    "data-name": "Ellipse 1019",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.997 6.212)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5865",
    "data-name": "Path 5865",
    d: "M43.068,49.465a.178.178,0,1,1,.178-.178A.178.178,0,0,1,43.068,49.465Zm0-.217a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.04.04,0,0,0-.044-.04Z",
    transform: "translate(-34.006 -43.01)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1020",
    "data-name": "Ellipse 1020",
    cx: 0.065,
    cy: 0.065,
    r: 0.065,
    transform: "translate(8.337 7.601)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    "data-name": "Path 5866",
    d: "M41.254,53.285a.174.174,0,0,1-.174-.174.178.178,0,1,1,.174.174Zm0-.214a.04.04,0,0,0-.04.04c0,.047.083.047.083,0a.04.04,0,0,0-.044-.04Z",
    transform: "translate(-32.852 -45.446)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    "data-name": "Path 5867",
    d: "M21.143,40.88a4.6,4.6,0,0,1-.866-.091,2.121,2.121,0,0,1-1.45-.986c-.834-1.356-.247-3.52-.221-3.625a4.238,4.238,0,0,1,1.388-2.588.156.156,0,0,1,.043-.04,5.557,5.557,0,0,1,1.812-1.131c.3-.105.845-.247,1.087,0,.319.315.188.776.04,1.309a4.491,4.491,0,0,0-.228,1.265,1.812,1.812,0,0,1-.692,1.512A5.042,5.042,0,0,1,23.619,38.3a1.678,1.678,0,0,1-.337,1.657A2.632,2.632,0,0,1,21.143,40.88Zm-1.294-6.666a3.726,3.726,0,0,0-.924,2.026c0,.047-.58,2.142.174,3.375a1.813,1.813,0,0,0,1.236.83,2.5,2.5,0,0,0,2.675-.725,1.381,1.381,0,0,0,.308-1.3,4.868,4.868,0,0,0-1.62-1.773.239.239,0,0,1-.072-.051,4.8,4.8,0,0,0-.645-.362A2,2,0,0,1,19.849,34.214Zm.413-.428a1.76,1.76,0,0,0,.852,2.139,5.2,5.2,0,0,1,.645.362,1.479,1.479,0,0,0,.649-1.309,4.879,4.879,0,0,1,.239-1.348c.145-.511.218-.808.047-.979-.036-.036-.272-.065-.725.094A5.184,5.184,0,0,0,20.262,33.786Z",
    transform: "translate(-18.381 -32.283)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1021",
    "data-name": "Ellipse 1021",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(3.237 5.331)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M27.246,47.171a.236.236,0,1,1,.236-.236A.236.236,0,0,1,27.246,47.171Zm0-.25v.033h.018l-.018-.036Z",
    transform: "translate(-23.882 -41.474)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1022",
    "data-name": "Ellipse 1022",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(2.204 5.709)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    "data-name": "Path 5869",
    d: "M24.447,48.178a.236.236,0,1,1,.206-.234.236.236,0,0,1-.206.234Zm0-.25v.033h.018l-.018-.022Z",
    transform: "translate(-22.116 -42.118)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1023",
    "data-name": "Ellipse 1023",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(3.306 6.245)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    "data-name": "Path 5870",
    d: "M27.436,49.681a.236.236,0,1,1,.236-.236A.236.236,0,0,1,27.436,49.681Zm0-.25v.033h0Z",
    transform: "translate(-24.003 -43.074)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1024",
    "data-name": "Ellipse 1024",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(3.52 6.93)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M28.032,51.574a.232.232,0,1,1,.232-.232A.232.232,0,0,1,28.032,51.574Zm0-.25v.036h0S28.039,51.324,28.032,51.324Z",
    transform: "translate(-24.386 -44.285)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1025",
    "data-name": "Ellipse 1025",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(2.08 6.68)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M24.052,50.871a.232.232,0,0,1-.232-.232.236.236,0,1,1,.232.232Zm0-.25v.036h.018l-.018-.04Z",
    transform: "translate(-21.848 -43.833)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1026",
    "data-name": "Ellipse 1026",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(1.323 5.81)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M21.959,48.481a.236.236,0,1,1,.232-.236.236.236,0,0,1-.232.236Zm0-.25v0Z",
    transform: "translate(-20.51 -42.309)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1027",
    "data-name": "Ellipse 1027",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(1.685 4.625)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M22.959,45.171a.236.236,0,1,1,.232-.236.232.232,0,0,1-.232.236Zm0-.25v.033h.018l-.018-.018Z",
    transform: "translate(-21.147 -40.199)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1028",
    "data-name": "Ellipse 1028",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(2.762 1.851)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M25.942,37.564a.232.232,0,1,1,.232-.232.232.232,0,0,1-.232.232Zm0-.25v.036h0a.018.018,0,0,0,0-.036Z",
    transform: "translate(-23.053 -35.354)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1029",
    "data-name": "Ellipse 1029",
    cx: 0.127,
    cy: 0.127,
    r: 0.127,
    transform: "translate(3.364 1.322)",
    fill: "#fedbb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M27.579,36.091a.236.236,0,1,1,.232-.232A.236.236,0,0,1,27.579,36.091Zm0-.25v.033h0Z",
    transform: "translate(-24.092 -34.41)",
    fill: "#fedbb7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferCrisps);
export default __webpack_public_path__ + "static/media/offer_crisps.7a4f91c065600e42c49e8d0458e497c6.svg";
export { ForwardRef as ReactComponent };